import { CustomsHistoryModel, CustomsModel, DashboardModel, DocumentsModel, GetCustomsHistoryQuery, PagedListingResponseOfTourListHistoryModel, TourModel } from "@core/services/api.service";


export class LoadCustomsListAction {
    static readonly type = '[CustomsList] Load Customs list';
}

export class LoadCustomsListSuccessAction {
    static readonly type = '[CustomsList] Load Customs list Success';

    constructor(public payload: { customs: CustomsModel[] }) { }
}

export class LoadCustomsListFailAction {
    static readonly type = '[CustomsList] Load Customs list Fail';
}

export class LoadCustomsHistoryListAction {
    static readonly type = '[CustomsHistoryList] Load Customs History List';
    constructor(public payload: { GetTourHistoryQuery: GetCustomsHistoryQuery }) { }
}

export class LoadCustomsHistoryListSuccessAction {
    static readonly type = '[CustomsHistoryList] Load Customs History List Success';

    constructor(public payload: { tourHistoryList: PagedListingResponseOfTourListHistoryModel }) { }
}

//----------------------------------------------------------------------------------

export class LoadListOfOpenChatsAction {
    static readonly type = '[CustomsHistory] Load List Of Open Chats';
}

export class LoadListOfOpenChatsSuccessAction {
    static readonly type = '[CustomsHistory] Load List Of Open Chats Success';

    constructor(public payload: { dash: DashboardModel[] }) { }
}

export class LoadListOfOpenChatsFailAction {
    static readonly type = '[CustomsHistory] Load List Of Open Chats Fail';
}

//-----------------------------------------------------------------------------------

export class AddCustomsMessageByIdAction {
    static readonly type = '[AddCustomsMessage] Add Customs Message Action';

    constructor(public id: number, public message: string, public isCustomRole: boolean) { }
}

export class AddCustomsMessageByIdSuccessAction {
    static readonly type = '[AddCustomsMessage] Add Customs Message Success';

    constructor(public payload: { tour: CustomsHistoryModel }) { }
}

export class AddCustomsMessageByIdFailAction {
    static readonly type = '[AddCustomsMessage] Add Customs Message Fail';
}

//-------------------------------------------------------------------------------------

export class LoadCustomsHistoryAction {
    static readonly type = '[CustomsHistoryMessages] Load Customs History Messages';

    constructor(public id: number, public amcoId: number) { }
}

export class LoadCustomsHistorySuccessAction {
    static readonly type = '[CustomsHistoryMessages] Load Customs History Messages Success';

    constructor(public payload: { history: CustomsHistoryModel[] }) { }
}

export class LoadCustomsHistoryFailAction {
    static readonly type = '[CustomsHistoryMessages] Load Customs History Messages Fail';
}

//-----------------------------------------------------------------------------------

export class LoadBmwHistoryAction {
    static readonly type = '[BmwHistoryMessages] Load BMW History Messages';

    constructor(public id: number, public amcoId: number) { }
}

export class LoadBmwHistorySuccessAction {
    static readonly type = '[BmwHistoryMessages] Load BMW History Messages Success';

    constructor(public payload: { history: CustomsHistoryModel[] }) { }
}

export class LoadBmwHistoryFailAction {
    static readonly type = '[BmwHistoryMessages] Load BMW History Messages Fail';
}

export class AddBmwMessageByIdAction {
    static readonly type = '[AddBmwMessage] Add BMW Message Action';

    constructor(public id: number, public message: string, public isBmwRole: boolean) { }
}

export class AddBmwMessageByIdSuccessAction {
    static readonly type = '[AddBmwMessage] Add BMW Message Success';

    constructor(public payload: { tour: CustomsHistoryModel }) { }
}

export class AddBmwMessageByIdFailAction {
    static readonly type = '[AddBmwMessage] Add BMW Message Fail';
}

//-----------------------------------------------------------------------------------

export class MarkChatAsResolvedAction {
    static readonly type = '[ResolvedChat] Mark Chat As Resolved action';

    constructor(public id: number, public tourId: number) { }
}

export class MarkChatAsResolvedSuccessAction {
    static readonly type = '[ResolvedChat] Mark Chat As Resolved Success';

    constructor(public payload: { chat: TourModel }) { }
}

export class MarkChatAsResolvedFailAction {
    static readonly type = '[ResolvedChat] Mark Chat As Resolved Fail';
}

//-----------------------------------------------------------------------------------

export class LoadCustomsHistoryListFailAction {
    static readonly type = '[CustomsHistoryList] Load Customs History List Fail';
}

export class ApplyFiltersToCustomsAction {
    static readonly type = '[CustomsList] Apply filter to customs';
}

export class SetCustomsCategoryFilterAction {
    static readonly type = '[CustomsList] Set Category Filter';
    constructor(public payload: { selectedCategory: string }) { }
}

export class SetDeclarationTypeAction {
    static readonly type = '[CustomsList] Set declaration type Filter';
    constructor(public payload: { selectedDeclarationType: string[] }) { }
}

export class SetCustomsDepartmentsFilterAction {
    static readonly type = '[CustomsList] Set Customs Departments Filter';
    constructor(public payload: { selectedDepartments: number[] }) { }
}

export class SetCustomsTypesFilterAction {
    static readonly type = '[CustomsList] Set Type Filter';
    constructor(public payload: { selectedTypes: number[] }) { }
}

export class SetGoodsLoadedFilterAction {
    static readonly type = '[Customs] Set Goods Loaded Filter';
    constructor(public payload: { selectedGoodsLoaded: boolean[] }) {}
}

export class SetCustomsStatusFilterAction {
    static readonly type = '[Customs] Set Customs Status Filter';
    constructor(public payload: { selectedCustomsStatus: string[] }) {}
}

export class RegisterSignalRForCustomsAction {
    static readonly type = '[CustomsList] Register SignalR Handlers For Customs';
}


export class UpdateCustomByTourIdAction {
    static readonly type = '[Customs] Update Custom By Tour ID';
    constructor(public tourId: number, public estimatedDateTime: Date | undefined, public updateType: number, public note: string) { }
}

export class UpdateCustomByTourIdSuccessAction {
    static readonly type = '[Customs] Update Custom By Tour ID Success';
    constructor(public payload: { custom: CustomsModel }) { }
}

export class UpdateCustomByTourIdFailAction {
    static readonly type = '[Customs] Update Custom By Tour ID Fail';
}

export class AllocateUserByTourIdAction {
    static readonly type = '[Customs] Allocate User By Tour ID';
    constructor(public id: number) { }
}

export class AllocateUserByTourIdSuccessAction {
    static readonly type = '[Customs] Allocate User By Tour ID Success';
    constructor(public payload: { tour: TourModel }) { }
}

export class AllocateUserByTourIdFailAction {
    static readonly type = '[Customs] Allocate User By Tour ID Fail';
}

export class GetDocumentsByAmcoIdAction {
    static readonly type = '[Customs] Get Documents By AMCO ID';
    constructor(public amcoId: number) { }
}

export class GetDocumentsByAmcoIdSuccessAction {
    static readonly type = '[Customs] Get Documents By AMCO ID Success';
    constructor(public payload: { documents: DocumentsModel[] }) { }
}

export class GetDocumentsByAmcoIdFailAction {
    static readonly type = '[Customs] Get Documents By AMCO ID Fail';
}

export class UploadDocumentAction {
    static readonly type = '[Customs] Upload Document';
    constructor(public amcoId: number, public file: File, public documentType: string, public Id: number) { }
}

export class UploadMultipleDocumentsAction {
    static readonly type = '[Customs] Upload Multiple Documents';
    constructor(public amcoId: number, public files: File[], public documentTypes: string[], public Id: number) { }
}

export class UploadDocumentSuccessAction {
    static readonly type = '[Customs] Upload Document Success';
    constructor(public payload: { document: DocumentsModel, amcoId: number }) { }
}

export class UploadMultipleDocumentsSuccessAction {
    static readonly type = '[Customs] Upload Multiple Documents Success';
    constructor(public payload: { documents: DocumentsModel[], amcoId: number }) { }
}

export class UploadDocumentFailAction {
    static readonly type = '[Customs] Upload Document Fail';
}
export class DownloadDocumentAction {
    static readonly type = '[Customs] Download Document';
    constructor(public amcoId: number, public fileName: string, public displayName?: string) {}
}

export class DownloadDocumentSuccessAction {
    static readonly type = '[Customs] Download Document Success';
}

export class DownloadDocumentFailAction {
    static readonly type = '[Customs] Download Document Fail';
    constructor(public error: any) {}
}

export class ViewDocumentAction {
    static readonly type = '[Customs] View Document';
    constructor(public amcoId: number, public fileName: string) {}
}

export class ViewDocumentFailAction {
    static readonly type = '[Customs] View Document Fail';
    constructor(public error: any) {}
}

export class GetDocumentTypesAction {
    static readonly type = '[Customs] Get Document Types';
    constructor(public amcoId: number) { }
}

export class GetDocumentTypesSuccessAction {
    static readonly type = '[Customs] Get Document Types Success';
    constructor(public payload: { documentTypes: any[] }) { }
}

export class GetDocumentTypesFailAction {
    static readonly type = '[Customs] Get Document Types Fail';
    constructor(public error: any) { }
}

export class UpdateDocumentTypeAction {
    static readonly type = '[Customs] Update Document Type';
    constructor(public amcoId: number, public fileName: string, public category: string) { }
}

export class UpdateDocumentTypeSuccessAction {
    static readonly type = '[Customs] Update Document Type Success';
    constructor(public payload: { documentType: any }) { }
}

export class UpdateDocumentTypeFailAction {
    static readonly type = '[Customs] Update Document Type Fail';
    constructor(public error: any) { }
}

export class ClearDocumentsAction {
    static readonly type = '[Customs] Clear Documents';
}

export class UpdateDocumentsCheckedAction {
    static readonly type = '[Customs] Update Documents Checked';
    constructor(public amcoId: number) { }
}

export class UpdateDocumentsCheckedSuccessAction {
    static readonly type = '[Customs] Update Documents Checked Success';
    constructor(public payload: { amcoId: number}) { }
}

export class UpdateDocumentsCheckedFailAction {
    static readonly type = '[Customs] Update Documents Checked Fail';
    constructor(public error: any) { }
}

export class UpdateUncCheckedAction {
    static readonly type = '[Customs] Update UCN Checked';
    constructor(public amcoId: number) { }
}

export class UpdateUncCheckedSuccessAction {
    static readonly type = '[Customs] Update UCN Checked Success';
    constructor(public payload: { amcoId: number}) { }
}

export class UpdateUncCheckedFailAction {
    static readonly type = '[Customs] Update UCN Checked Fail';
    constructor(public error: any) { }
}

//-----------------------------------------------------------------------------------

export class UpdateTadClosedAction {
  static readonly type = '[Customs] Update TAD Closed';
  constructor(public amcoId: number) { }
}

export class UpdateTadClosedSuccessAction {
  static readonly type = '[Customs] Update TAD Closed Success';
  constructor(public payload: { amcoId: number }) { }
}

export class UpdateTadClosedFailAction {
  static readonly type = '[Customs] Update TAD Closed Fail';
  constructor(public error: any) { }
}

// New Messages Notification
export class SetHasNewMessagesForCustomsListAction {
  static readonly type = '[Customs] Set Has New Messages For Customs List';
  constructor(public payload: { hasNewMessages: boolean }) { }
}

export class ClearNewMessagesForCustomsListAction {
  static readonly type = '[Customs] Clear New Messages For Customs List';
}

export class SetHasNewMessagesForManagedToursAction {
  static readonly type = '[Customs] Set Has New Messages For Managed Tours';
  constructor(public payload: { hasNewMessages: boolean }) { }
}

export class ClearNewMessagesForManagedToursAction {
  static readonly type = '[Customs] Clear New Messages For Managed Tours';
}
